import { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useTranslation } from "../../hooks/useTranslation";
import { Button, Card } from "../primitives";
import useTimedError from "../../hooks/useTimedError";
import { useNavigate } from "react-router-dom";
import { catchError } from "../../ErrorUtility";
import { useDatabase } from "../../contexts/DatabaseContext";

export default function VerifyNewEmail({ setIsOpen, setError: parentSetError, email, loading, setLoading, isInboxEmail, sentEmailLock, onSuccess }) {
    const t = useTranslation();
    const [verificationCode, setVerificationCode] = useState(['', '', '', '', '', '']);
    const { verifyReverificationCode, sendReverificationCode } = useAuth();
    const [error, setError] = useTimedError();
    const navigate = useNavigate();
    const { createAccountActionEvent } = useDatabase();

    const [countdown, setCountdown] = useState(30);

    function handleCodeChange(index, value) {
        const newCode = [...verificationCode];
        newCode[index] = value;
        setVerificationCode(newCode);
    }

    async function handleCodeSubmit(e) {
        e.preventDefault();
        setLoading(true);
        console.log(verificationCode.join(''));
        const [result, error] = await catchError(verifyReverificationCode, verificationCode.join(''), isInboxEmail);
        if (error) {
            console.log(error);
            setError(error.message);
        } else if (!isInboxEmail) {
            await createAccountActionEvent("update_email");
            navigate('/login', { state: { email } });
        } else {
            await onSuccess();
            setIsOpen(false);
            sentEmailLock.current = false;
            createAccountActionEvent("update_inbox_email");
        }
        setLoading(false);
    }

    const handleResend = (e) => {
        e.preventDefault();
        sendReverificationCode(email);
        setCountdown(60);
    };

    useEffect(() => {
        if (isInboxEmail && !sentEmailLock.current) {
            const sendCode = async () => {
                sentEmailLock.current = true;
                await sendReverificationCode(email);
            };
            sendCode();
        }
    }, []);

    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [countdown]);

    return (
        <Card ctype="white">
            <Card.Body>
                <h2 className="text-center mb-4">{t('Verify new email')}</h2>
                <div className="text-center">{t('Please enter the code sent to {{email}}', { email})}</div>
                <div className="text-center">
                    {countdown > 0 ? (
                        <span>{t('Code sent! Resend available in {{countdown}}s', { countdown })}</span>
                    ) : (
                        <>No code? <a href="#" onClick={handleResend}>{t('Resend')}</a></>
                    )}
                </div>
                <form className="" onSubmit={handleCodeSubmit}>
                    <div className="mh-auto row-flex justify-content-center">
                        {[...Array(6)].map((_, index) => (
                            <input
                                key={index}
                                type="text"
                                maxLength="1"
                                value={verificationCode[index]}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^[0-9]$/.test(value) || value === '') {
                                        handleCodeChange(index, value);
                                    }
                                }}
                                onPaste={(e) => {
                                    e.preventDefault();
                                    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
                                    const newCode = [...verificationCode];
                                    for (let i = 0; i < pastedData.length; i++) {
                                        if (index + i < 6) {
                                            newCode[index + i] = pastedData[i];
                                        }
                                    }
                                    setVerificationCode(newCode);
                                    // Focus the next empty input or the last filled input
                                    const nextEmptyIndex = newCode.findIndex((val, idx) => idx >= index && !val);
                                    const focusIndex = nextEmptyIndex === -1 ? 5 : nextEmptyIndex;
                                    document.querySelectorAll('.auth-verify-input')[focusIndex].focus();
                                }}
                                className="auth-verify-input"
                                onKeyUp={(e) => {
                                    if (e.target.value && e.target.nextElementSibling) {
                                        e.target.nextElementSibling.focus();
                                    }
                                    if (e.key === "Backspace" && !e.target.value && e.target.previousElementSibling) {
                                        e.target.previousElementSibling.focus();
                                    }
                                }}
                            />
                        ))}
                    </div>
                    {/* <Form.Group>
                        <Form.Label>Get the security code via:</Form.Label>
                        <div>
                            <Form.Check
                                type="radio"
                                id="email"
                                name="sendCodeOption"
                                label="Email"
                                value="email"
                                checked={selectedOption === "email"}
                                onChange={handleOptionChange}
                                required
                            />
                            <Form.Check
                                type="radio"
                                id="phone"
                                name="sendCodeOption"
                                label="Phone"
                                value="phone"
                                checked={selectedOption === "phone"}
                                onChange={handleOptionChange}
                                required
                            />
                        </div>
                    </Form.Group> */}
                    <Button disabled={!verificationCode.every(code => code !== '')} loading={loading} error={error} className="w-100 mt-3" buttonType="submit">
                        {error || t('Submit')}
                    </Button>
                </form>
                <Button className="w-100 mt-3" buttonType="button" onClick={() => setIsOpen(false)}>{t('Cancel')}</Button>
            </Card.Body>
        </Card>
    )
}